import React from "react";
import './Home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';


const Home = () => {
    return(
    <div id="home">

        <div className="home">
            <div className="intro">
                <h5> THE BEST CRYPTOCURRENCY EVER </h5>
                <h1>Cryptocurrency Perfect <br></br><span className="invest">Investment</span>  </h1>
            </div>

        <div className="status">
            <div className="status1">
                <h2>25M+</h2>
                <p>People who have joined <br></br> Cybse</p>
            </div>
            <div className="status2">
                <h2>200k+</h2>
                <p>Famous People Playing <br></br> Crybse</p>
            </div>
            <div className="status3">
                <h2>250+</h2>
                <p>Cooperation With Big <br></br> Companies</p>
            </div>
         </div>
         <div class="started">
              <span className="start"><a href="#started">Let's Get Started &nbsp;<FontAwesomeIcon icon={faArrowTrendUp} />
              </a></span>
              <span className="how"><a href="#how">How It Works</a></span>
         </div>

        </div>
        
    </div>
    )
}
export default Home;